var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      staticClass: "chat-open",
      on: { click: _vm.openChat, mousedown: _vm.move },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }